export class FAQ {

  constructor() {

  }
}
